import "./partners.css";
import { Controller as BaseController } from "@hotwired/stimulus";

// NOTE: someday we will remove all this and use CSS gap decorations instead
// https://www.w3.org/TR/css-gaps-1/
// https://css-tricks.com/the-gap-strikes-back-now-stylable/
// https://github.com/Fyrd/caniuse/issues/7335
export class Controller extends BaseController {
  static targets = ["list", "wrapper"];

  connect() {
    this.boundUpdate = this.updateSeparators.bind(this);
    requestAnimationFrame(this.boundUpdate);

    window.addEventListener("resize", this.boundUpdate);
  }

  disconnect() {
    window.removeEventListener("resize", this.boundUpdate);
  }

  updateSeparators() {
    const links = this.wrapperTargets;
    if (links.length === 0) return;

    this.resetClasses(links);
    this.markRowExtremes(links);
  }

  resetClasses(links) {
    links.forEach((link) =>
      link.classList.remove("Partners-start-of-row", "Partners-end-of-row")
    );
  }

  markRowExtremes(links) {
    let currentRowTop = null;
    let firstInRow = null;
    let lastInRow = null;

    for (const link of links) {
      const top = link.getBoundingClientRect().top;

      if (currentRowTop === null) {
        currentRowTop = top;
        firstInRow = link;
        lastInRow = link;
        continue;
      }

      if (Math.abs(top - currentRowTop) > 8) {
        this.markRow(firstInRow, lastInRow);
        currentRowTop = top;
        firstInRow = link;
      }

      lastInRow = link;
    }

    this.markRow(firstInRow, lastInRow);
  }

  markRow(first, last) {
    if (first) first.classList.add("Partners-start-of-row");
    if (last) last.classList.add("Partners-end-of-row");
  }
}
